import { map } from "rxjs/operators";
/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
  ContentChild,
} from "@angular/core";
import { NgbActiveModal, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import {
  ECaseStatus,
  EServicePlace,
  ECasePriority,
  ErrorTypeService,
  ErrorTypeListResponse,
} from "../../../api";
import { MapsAPILoader } from "@agm/core";
import { DataService } from "../../../../shared/service/data.service";
import { CustomdatepickerComponent } from "../../../../shared/modules/customdatepicker.component";
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: "app-form",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class FormComponent implements OnInit {
  @ViewChild("addr") public searchElement: ElementRef;
  @ContentChild(CustomdatepickerComponent)
  datepickerViewChild: CustomdatepickerComponent;

  previewImage: SafeUrl | undefined;

  user = JSON.parse(localStorage.getItem("currentUser"));
  viewOnly = false;
  data;
  caseForm: FormGroup;
  photos: string[];
  photoAddNew: File[] = [];
  currentStatus;
  ECaseStatus = ECaseStatus;
  ECasePriority = ECasePriority;
  EServicePlace = EServicePlace;
  caseStatus;
  errorTypes: ErrorTypeListResponse[];
  allStatus;
  quick = false;
  address = "";
  newStatus;
  currentErrorType;
  payment = true;
  currentRepairshop = null;
  currentRepairer = null;
  oldServicePlace;
  keys = Object.keys;
  today = new Date();
  minDate = {
    year: this.today.getFullYear(),
    month: this.today.getMonth() + 1,
    day: this.today.getDate(),
  };
  constructor(
    public activeModal: NgbActiveModal,
    private dt: DataService,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private errorTypeService: ErrorTypeService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    console.log(this.data.overview)
    if (this.data.overview.errorTypeId == 0) {
      this.data.overview.errorTypeId = null;
    }
    this.caseStatus = this.dt.caseStatusUpdate;
    this.allStatus = this.dt.caseStatus;
    this.currentStatus = this.data.overview.status;
    this.currentErrorType = this.data.overview.errorTypeId;
    this.currentRepairer = this.data.overview.repairerId;
    this.currentRepairshop = this.data.overview.repairshopId;
    this.oldServicePlace = this.data.overview.servicePlace;
    this.photos = this.data.overview.listPhoto;
    let date = null;
    let time = null;

    if (
      this.data.overview.serviceTime > 0 &&
      this.data.overview.servicePlace === EServicePlace.AtCustomerSite
    ) {
      const dt = new Date(this.data.overview.serviceTime * 1000);
      date = {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: dt.getDate(),
      };
      time = {
        hour: dt.getHours(),
        minute: dt.getMinutes(),
      };
    }
    this.mapsAPILoader.load().then(() => {
      const autocomplete = new google.maps.places.Autocomplete(
        this.searchElement.nativeElement,
        { types: ["address"] }
      );
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          const place: google.maps.places.PlaceResult = autocomplete.getPlace();
          this.data.overview.address = place.formatted_address;
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }
        });
      });
    });
    this.caseForm = new FormGroup(
      {
        status: new FormControl(this.newStatus),
        errorType: new FormControl(this.currentErrorType),
        priority: new FormControl(this.data.overview.priority),
        repairshopId: new FormControl(),
        servicePlace: new FormControl(this.data.overview.servicePlace),
        repairer: new FormControl(this.data.overview.repairerId),
        address: new FormControl(this.data.overview.address),
        messageToSP: new FormControl(),
        messageToCustomer: new FormControl(),
        messageRepairer: new FormControl(),
        messageCustomer: new FormControl(),
        time: new FormControl(time),
        date: new FormControl(date),
        sendRepaier: new FormControl(false),
        sendEmailToCustomer: new FormControl(true),
        sendNotificationToCustomer: new FormControl(true),
        paymentInWarehouse: new FormControl(
          this.data.overview.paymentInWarehouse != null
            ? this.data.overview.paymentInWarehouse
            : false
        ),
        description: new FormControl(),
        solution: new FormControl(this.data.overview.solution)
      },
      validateCase
    );
    if (
      this.currentStatus !== ECaseStatus.NewUnAssigned &&
      this.currentStatus !== ECaseStatus.Pending &&
      (this.currentStatus !== ECaseStatus.Received ||
        (this.currentStatus === ECaseStatus.Received &&
          this.data.overview.servicePlace === EServicePlace.AtRepairshop))
    ) {
      this.caseForm.controls.repairshopId.disable();
      this.caseForm.controls.servicePlace.disable();
    }
    if (
      this.currentStatus === ECaseStatus.Returned ||
      this.currentStatus === ECaseStatus.Closed
    ) {
      this.caseForm.controls.repairer.disable();
      this.caseForm.controls.priority.disable();
    }
    this.caseForm.controls.repairshopId.valueChanges.subscribe((value) =>
      this.changeRepairshop()
    );
    this.caseForm.controls.repairer.valueChanges.subscribe((value) =>
      this.changeRepairer()
    );
    this.caseForm.controls.servicePlace.valueChanges.subscribe((value) =>
      this.changeRepairshop()
    );
    this.errorTypeService.apiErrorTypesGet(1).subscribe((data) => {
      this.errorTypes = data;
    });
  }
  get addr() {
    return this.caseForm.get("address");
  }
  get date() {
    return this.caseForm.get("date");
  }
  get time() {
    return this.caseForm.get("time");
  }
  get servicePlace() {
    return this.caseForm.get("servicePlace");
  }
  get messageRepairer() {
    return this.caseForm.get("messageRepairer");
  }
  get messageCustomer() {
    return this.caseForm.get("messageCustomer");
  }
  uploadFile(e: any) {
    var files = Array.from(e.target.files)
    const newFiles = [...this.photoAddNew, ...files]
    this.photoAddNew = newFiles as File[];
}
  removeFile(img: string, file: File = null) {
    this.photos = this.photos.filter((o) => o != img);
    this.photoAddNew = this.photoAddNew.filter((o) => o != file);
  }
  chooseFile() {
    document.getElementById("uploadImg").click();
  }

  viewFile(file: File): SafeUrl {
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
    }
  }

  changeRepairshop() {
    if (
      this.data.overview.repairshopId !== this.currentRepairshop &&
      this.caseForm.controls.servicePlace.value === EServicePlace.AtRepairshop
    ) {
      this.messageCustomer.clearValidators();
    }
    this.messageCustomer.updateValueAndValidity();
  }

  changeServicePlace() {
    if (
      this.oldServicePlace === this.EServicePlace.AtCustomerSite &&
      this.servicePlace.value === this.EServicePlace.AtRepairshop
    ) {
      this.caseForm.controls.status.disable();
      this.data.overview.repairshopId = this.data.shopList[0].repairshopId;
    } else {
      this.caseForm.controls.status.enable();
    }
  }
  changeRepairer() {
    /* if (this.data.overview.repairerId !== this.currentRepairer) {
      this.messageRepairer.setValidators([Validators.required]);
    } else {
      this.messageRepairer.clearValidators();
    }
    this.messageRepairer.updateValueAndValidity(); */
  }

  checkStatus(status) {
    if (this.payment) {
      return true;
    } else {
      switch (this.currentStatus) {
        case ECaseStatus.NewUnAssigned:
          break;
        case ECaseStatus.Pending:
          if (status === ECaseStatus.Pending) {
            return true;
          }
          if (status === ECaseStatus.Repairing) {
            return true;
          }
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          break;
        case ECaseStatus.Repairing:
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          if (status === ECaseStatus.Repairing) {
            return true;
          }
          break;
        case ECaseStatus.Delayed:
          if (status === ECaseStatus.Delayed) {
            return true;
          }
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          break;
        case ECaseStatus.Finished:
          if (status === ECaseStatus.Finished) {
            return true;
          }
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          break;
        case ECaseStatus.Returned:
          if (status !== ECaseStatus.Closed) {
            return true;
          }
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          break;
        default:
          if (status === ECaseStatus.Closed && this.viewOnly) {
            return true;
          }
          break;
      }
    }
    return false;
  }
  closeModal() {
    this.activeModal.dismiss("close");
  }
  saveModal() {
    if (
      this.data.overview.servicePlace &&
      (this.caseForm.get("date").value || this.caseForm.get("time").value)
    ) {
      const date = new Date(
        this.caseForm.value.date.year,
        this.caseForm.value.date.month,
        this.caseForm.value.date.day,
        this.caseForm.value.time.hour,
        this.caseForm.value.time.minute
      );
      this.data.overview.serviceTime = Math.floor(date.getTime() / 1000);
    }
  
    if (this.servicePlace.value === this.EServicePlace.AtRepairshop) {
      this.data.overview.serviceTime = 0;
    }
  
    this.data.overview.messageToCustomer = [];
    this.data.overview.messageToRepairer = [];
  
    if (this.caseForm.value.messageToSP) {
      this.data.overview.messageToRepairer.push(this.caseForm.value.messageToSP);
    }
    if (this.caseForm.value.messageToCustomer) {
      this.data.overview.messageToCustomer.push(this.caseForm.value.messageToCustomer);
    }
  
    if (this.data.overview.repairerId !== this.currentRepairer && this.caseForm.value.messageRepairer) {
      this.data.overview.messageToRepairer.push(this.caseForm.value.messageRepairer);
    }
    if (this.data.overview.repairshopId !== this.currentRepairshop) {
      this.data.overview.messageToCustomer.push(this.caseForm.value.messageCustomer);
    }
  
    if (this.newStatus) {
      this.data.overview.status = this.newStatus;
    }
  
    if (
      this.oldServicePlace === this.EServicePlace.AtCustomerSite &&
      this.servicePlace.value === this.EServicePlace.AtRepairshop
    ) {
      this.data.overview.status = this.ECaseStatus.Pending;
    }
  
    if (
      this.oldServicePlace === this.EServicePlace.AtRepairshop &&
      this.servicePlace.value === this.EServicePlace.AtCustomerSite
    ) {
      this.data.overview.status = this.ECaseStatus.Received;
    }

    if (this.caseForm.value.paymentInWarehouse) {
      this.data.overview.status = this.ECaseStatus.Finished;
    }
  
    this.data.overview.files = this.photos;
    this.data.overview.newFiles = this.photoAddNew;
    this.data.overview.sendNotificationToCustomer = this.caseForm.value.sendNotificationToCustomer;
    this.data.overview.sendEmailToCustomer = this.caseForm.value.sendEmailToCustomer;
    this.data.overview.paymentInWarehouse = this.caseForm.value.paymentInWarehouse;
  
    this.activeModal.close(this.data.overview);
  }
  
}

function validateCase(caseForm: FormGroup): { [key: string]: boolean } {
  if (
    caseForm.controls["servicePlace"].value === EServicePlace.AtCustomerSite
  ) {
    if (!caseForm.controls["address"].value) {
      return { invalidAddress: true };
    }
    /* if (!caseForm.get('date').value) {
      return { 'invalidDate': true };
    }
    if (!caseForm.get('time').value) {
      return { 'invalidTime': true };
    } */
  }
  if (caseForm.get("status").value === ECaseStatus.Delayed) {
    if (!caseForm.get("messageToSP").value) {
      return { invalidSP: true };
    }
    if (!caseForm.get("messageToCustomer").value) {
      return { invalidCustomer: true };
    }
  }
  return null;
}
